import React from 'react';
import SlideUpDownNav from './../inc/SlideUpDownNav';

import SwiperCore, {Navigation, Autoplay, A11y, EffectFade } from 'swiper';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper-bundle.css';


import img from './../../assets/img/about/discussion.jpg';
import vdoPoster from './../../assets/media/mole_poster.jpg';
import abtVdo1 from './../../assets/media/studio_01_com.mp4';
import abtVdo2 from './../../assets/media/10_Mole_studio_03(1).mp4';

SwiperCore.use([ Navigation, Autoplay, EffectFade, A11y]);

class Intro extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        let _this = this;
        let page_id = this.props.page_id;
        let banners = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.banner : [];    
        let content = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.content : '';    

        return (
            <section className="section">
                <SlideUpDownNav {...this.props} fullpageApi={this.props.fullpageApi}  upBtn={false}/>

                <div className="mole__about--intro fullW">
                    <div className="main-container">
                        <div className="inner-container">
                            <h2 className="font-lg-head c-general w-100">About</h2>
                            {/* <figure className="d-inline-block">
                                <img src={img} alt="Mole" title="Mole"/>
                            </figure> */}
                            <div className="media-container">
                                <Swiper 
                                    autoplay
                                    effect="fade"
                                    loop={false}
                                    speed={1500}
                                    navigation={{
                                        prevEl: '.swiper-hero--prev',
                                        nextEl: '.swiper-hero--next',
                                    }}

                                    onSlideChange={(swiper) => {
                                        let allSwiper      = document.querySelectorAll('.swiper-slide');
                                        let currentSwiper  = [...allSwiper][swiper.activeIndex];
                                        let prevSwiper     = [...allSwiper][swiper.previousIndex];
                                        let nextSwiper     = [...allSwiper][swiper.nextIndex];

                                        prevSwiper && prevSwiper.querySelector('video') ? prevSwiper.querySelector('video').pause() : '';
                                        nextSwiper && nextSwiper.querySelector('video') ? nextSwiper.querySelector('video').pause() : '';
                                        // currentSwiper.querySelector('video') ? currentSwiper.querySelector('video').play() : '';
                                    }}
                                    
                                >
                                    {/* <div className="swiper-center-nav">
                                        <span className="swiper-hero--prev">
                                            <svg version="1.1" x="0px" y="0px" viewBox="0 0 35.7 60">
                                                <polygon points="4.7,34.1 5.2,34.6 5.2,34.6 15.8,45.3 30.5,60 35.7,54.8 21,40.1 10.3,29.5 20.4,19.3 34.6,5.2 29.5,0  15.3,14.2 5.2,24.3 5.2,24.3 4.8,24.6 0,29.5 0,29.5 "/>
                                            </svg>
                                        </span>

                                        <span className="swiper-hero--next">
                                            <svg version="1.1" x="0px" y="0px" viewBox="0 0 35.7 60">
                                                <polygon points="35.7,29.5 35.7,29.5 30.9,24.6 30.5,24.3 30.5,24.3 20.4,14.2 6.2,0 1.1,5.2 15.3,19.3 25.4,29.5 14.7,40.1 0,54.8 5.2,60 19.9,45.3 30.5,34.6 30.5,34.6 31,34.1 "/>
                                            </svg>
                                        </span>
                                    </div> */}
                                    {
                                        [...banners].map((banner, key) => {
                                            
                                            return (
                                                banner.banner_type == 'image' 
                                                
                                                ? 

                                                <SwiperSlide>
                                                    <figure className="media-ratio-container">
                                                        <img src={banner.image.url} alt="Mole" title="Mole"/>
                                                    </figure>
                                                </SwiperSlide>

                                                :

                                                <SwiperSlide>
                                                    <div className="media-ratio-container">
                                                        <video autoPlay muted playsInline loop poster={vdoPoster}>
                                                            <source src={banner.video} type="video/mp4"></source>
                                                        </video>
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        })
                                    }
                                </Swiper>
                            </div>
                            {
                                content != '' &&
                                    <article className="font-md" dangerouslySetInnerHTML={{__html:content}} />
                            }
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default Intro;



// WEBPACK FOOTER //
// ./src/components/About/Hero.js